/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 1/8/20
 * Time: 5:24 PM
 */


module.exports = {
  chart: {
    type: "pie",
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    height: 250
  },
  title: {
    text: "",
    x: -20 //center
  },
  subtitle: {
    text: "",
    x: -20
  },
  credits: {
    enabled: false
  },
  xAxis: {
    allowDecimals: false,
    labels: {
      formatter: function() {
        return this.value; // clean, unformatted number for year
      }
    },
    categories: []
  },
  yAxis: {
    title: {
      text: "Number of transactions"
    },
    labels: {
      formatter: function() {
        return this.value;
      }
    }
  },
  tooltip: {
    pointFormat: "{series.name} <b>{point.y:,.0f}</b><br/>" // {point.x}
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: true,
        format: '<b>{point.name}</b>: {point.y:,.0f}',
      }
    }
  },
  series: [{
    name: " ",
    data: []
  }]

};
